import { useContext, useState } from 'react';

import { CartContext } from '../contexts/cart.context';
import { useNotification } from '../contexts/notification.context';

// Choisir un palier de grammage puis l'ajouter au panier : le même geste est offert
// par la fiche produit et par la vignette de la boutique.
export const useProductSelection = (product) => {
  const { addItemToCart } = useContext(CartContext);
  const { notify } = useNotification();

  const [totalPrice, setTotalPrice] = useState(0);
  const [productToAdd, setProductToAdd] = useState(product);

  const selectPrice = (price) => {
    // Le rang du palier est encodé dans l'id en décimale (ex: 417.2) pour que deux
    // grammages d'une même fleur restent deux lignes distinctes du panier. Il part
    // de 1, rang qu'occupait l'option dans la liste déroulante native, dont la
    // première entrée était l'invite de sélection — et que `getOrderId.php` attend.
    const position =
      product.prices.findIndex((item) => item.value === price) + 1;

    setTotalPrice(price);
    setProductToAdd({
      ...product,
      price,
      quantity: 1,
      id: product.id + position / 10
    });
  };

  const addProductToCart = () => {
    addItemToCart(productToAdd, true);
    // Le sélecteur repart sur son invite : sans ça, la vignette resterait figée
    // sur un choix déjà validé.
    setTotalPrice(0);
    notify('Sélection ajoutée à votre panier');
  };

  return { totalPrice, selectPrice, productToAdd, addProductToCart };
};

export default useProductSelection;
